import React, {useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/helpers-css-strings";
import {CloseIcon, DownloadIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";

import {AuthCard} from "../../../auth/components/AuthCard";
import {gtmOfferGalleryEvents} from "../../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {gtmEventPropertyDownloadPlanRegister} from "../../../tracking/google_tag_manager/gtm_event_property_download_plan_register";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {GalleryHolderPropertyPlanAuthConfirmationModal} from "./GalleryHolderPropertyPlanAuthConfirmationModal";

interface IProps {
    propertyPlan: string;
    onPlanButtonClick: () => void;
    modalState?: OfferModalActiveTab | null;
}

export const GalleryHolderPropertyPlanButton = (props: IProps) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showAuthCard, setShowAuthCard] = useState(false);

    const isAuthenticated = useIsAuthenticated();

    const onAuthSuccess = () => {
        setShowAuthCard(false);
        setShowConfirmationModal(true);
    };

    const onModalClose = () => {
        setShowAuthCard(false);
        setShowConfirmationModal(false);
    };

    const onButtonClick = () => {
        props.modalState && gtmOfferGalleryEvents.onPlanDownloadButton(props.modalState);
        if (isAuthenticated) {
            props.onPlanButtonClick;
        } else {
            setShowAuthCard(true);
        }
    };

    return (
        <>
            <div className={downloadButtonWrapperStyle}>
                <Button
                    className={buttonStyle}
                    variant="filled_primary"
                    href={isAuthenticated ? props.propertyPlan : undefined}
                    onClick={onButtonClick}
                    iconLeft={DownloadIcon}
                    target="_blank"
                >
                    Pobierz rzut
                </Button>
            </div>
            <Modal
                isOpen={showAuthCard}
                onModalClose={onModalClose}
                className={modalStyle}
                closeButton={(closeModal) => <CloseIcon size="2" wrapperSize="4.8" onClick={closeModal} className={closeButtonStyle} />}
            >
                <div className={authCardStyle}>
                    <Modal.CloseButton placement="right" />
                    <AuthCard
                        key="auth"
                        onAuthSuccess={onAuthSuccess}
                        userSource={UserSource.REGISTER_PROPERTY_PLAN}
                        gtmEventData={() => gtmEventPropertyDownloadPlanRegister()}
                        modalTitle={
                            <>
                                Załóż konto, aby pobrać rzut <br /> nieruchomości{" "}
                            </>
                        }
                    />
                </div>
            </Modal>
            <Modal
                isOpen={showConfirmationModal}
                onModalClose={onModalClose}
                closeButton={(closeModal) => <CloseIcon size="2" wrapperSize="4.8" onClick={closeModal} className={closeButtonStyle} />}
                className={modalStyle}
            >
                <Modal.CloseButton placement="right" />
                <Modal.Content className={modalContentStyle}>
                    <GalleryHolderPropertyPlanAuthConfirmationModal downloadButtonClick={props.onPlanButtonClick} propertyPlan={props.propertyPlan} />
                </Modal.Content>
            </Modal>
        </>
    );
};

const downloadButtonWrapperStyle = css({
    md: {
        display: "flex",
        justifyContent: "center",
        mt: 3,
        mb: 1,
        width: "100%",
        my: 3,
        textAlign: "center"
    }
});

const authCardStyle = css({
    display: "flex",
    justifyContent: "center"
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto"
    }
});

const modalStyle = css({
    zIndex: 10000,
    bottom: -1,
    borderRadius: 2,
    overflow: "unset",
    width: "100%",
    md: {
        bottom: "unset",
        maxWidth: "500px"
    }
});

const modalContentStyle = css({
    width: "100%",
    md: {
        borderRadius: 2
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    boxShadow: elevation(),
    md: {
        top: -3,
        right: -3,
        transform: "unset",
        boxShadow: elevation()
    }
});
import React, {useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/helpers-css-strings";
import {CloseIcon, DownloadIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";

import {AuthCard} from "../../../auth/components/AuthCard";
import {gtmOfferGalleryEvents} from "../../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {gtmEventPropertyDownloadPlanRegister} from "../../../tracking/google_tag_manager/gtm_event_property_download_plan_register";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {GalleryHolderPropertyPlanAuthConfirmationModal} from "./GalleryHolderPropertyPlanAuthConfirmationModal";

interface IProps {
    propertyPlan: string;
    onPlanButtonClick: () => void;
    modalState?: OfferModalActiveTab | null;
}

export const GalleryHolderPropertyPlanButton = (props: IProps) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showAuthCard, setShowAuthCard] = useState(false);

    const isAuthenticated = useIsAuthenticated();

    const onAuthSuccess = () => {
        setShowAuthCard(false);
        setShowConfirmationModal(true);
    };

    const onModalClose = () => {
        setShowAuthCard(false);
        setShowConfirmationModal(false);
    };

    const onButtonClick = () => {
        props.modalState && gtmOfferGalleryEvents.onPlanDownloadButton(props.modalState);
        if (isAuthenticated) {
            props.onPlanButtonClick;
        } else {
            setShowAuthCard(true);
        }
    };

    return (
        <>
            <div className={downloadButtonWrapperStyle}>
                <Button
                    className={buttonStyle}
                    variant="filled_primary"
                    href={isAuthenticated ? props.propertyPlan : undefined}
                    onClick={onButtonClick}
                    iconLeft={DownloadIcon}
                    target="_blank"
                >
                    Pobierz rzut
                </Button>
            </div>
            <Modal
                isOpen={showAuthCard}
                onModalClose={onModalClose}
                className={modalStyle}
                closeButton={(closeModal) => <CloseIcon size="2" wrapperSize="4.8" onClick={closeModal} className={closeButtonStyle} />}
            >
                <div className={authCardStyle}>
                    <Modal.CloseButton placement="right" />
                    <AuthCard
                        key="auth"
                        onAuthSuccess={onAuthSuccess}
                        userSource={UserSource.REGISTER_PROPERTY_PLAN}
                        gtmEventData={() => gtmEventPropertyDownloadPlanRegister()}
                        modalTitle={
                            <>
                                Załóż konto, aby pobrać rzut <br /> nieruchomości{" "}
                            </>
                        }
                    />
                </div>
            </Modal>
            <Modal
                isOpen={showConfirmationModal}
                onModalClose={onModalClose}
                closeButton={(closeModal) => <CloseIcon size="2" wrapperSize="4.8" onClick={closeModal} className={closeButtonStyle} />}
                className={modalStyle}
            >
                <Modal.CloseButton placement="right" />
                <Modal.Content className={modalContentStyle}>
                    <GalleryHolderPropertyPlanAuthConfirmationModal downloadButtonClick={props.onPlanButtonClick} propertyPlan={props.propertyPlan} />
                </Modal.Content>
            </Modal>
        </>
    );
};

const downloadButtonWrapperStyle = css({
    md: {
        display: "flex",
        justifyContent: "center",
        mt: 3,
        mb: 1,
        width: "100%",
        my: 3,
        textAlign: "center"
    }
});

const authCardStyle = css({
    display: "flex",
    justifyContent: "center"
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto"
    }
});

const modalStyle = css({
    zIndex: 10000,
    bottom: -1,
    borderRadius: 2,
    overflow: "unset",
    width: "100%",
    md: {
        bottom: "unset",
        maxWidth: "500px"
    }
});

const modalContentStyle = css({
    width: "100%",
    md: {
        borderRadius: 2
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    boxShadow: elevation(),
    md: {
        top: -3,
        right: -3,
        transform: "unset",
        boxShadow: elevation()
    }
});
